<template>
    <v-container>
        <v-row justify="center">
            <v-card class="loginCard">
                <v-card-title>
                    <v-row justify="center">  
                        <span style="text-align: center;">帳戶登入</span>
                    </v-row>
                </v-card-title>
                <v-card-actions>
                    <v-col cols=12>
                        <v-text-field id="username" v-model="login_data.account" label="帳號: 請輸入e-mail"></v-text-field>
                        <v-text-field id="password" v-model="login_data.password" type="password" label="密碼: 請輸入密碼"></v-text-field>
                        <v-btn @click="login()" color="success" width="100%">登入</v-btn>
                        <v-row justify="end">
                            <span 
                                class="forgotPassword"
                                @click="forgot_password_dialog=true">忘記密碼?
                            </span>
                        </v-row>
                    </v-col>     
                    
                </v-card-actions>
            </v-card>
        
            <v-dialog v-if="forgot_password_dialog==true" v-model="forgot_password_dialog" persistent width="450px">
                <v-card width="450px">
                    <v-card-title>
                        <v-row justify="center">
                            <span style="text-align: center;">忘記密碼</span>
                        </v-row>
                        <v-icon @click="forgot_password_dialog=false; emailField=''">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-actions>
                        <v-col cols=12>
                            <v-text-field 
                                v-model="emailField" 
                                label="請輸入您登入的電子信箱"
                                :rules="[rules.email, rules.empty]"
                            ></v-text-field>
                            <v-btn @click="send_lock=true; forgot_password_submit(); send_lock=false;" color="success" width="100%" :disabled="send_lock==true">送出</v-btn>
                        </v-col>     
                    </v-card-actions>       
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL
var EXPIRATION_DELTA_HOURS = Number(process.env.VUE_APP_EXPIRATION_DELTA_HOURS)
export default {
    data(){
        return {
            login_data: {
                account: '',
                password: '',
            },
            forgot_password_dialog: false,
            emailField: '',
            rules: {
                empty: v => !!v || 'E-mail為必填',
                email: v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mai格式不符'
            },     
            send_lock: false,   
        }
    },
    methods: {
        login(){

            var data = JSON.stringify({"username": this.login_data.account,
                                       "password": this.login_data.password})
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;

            xhr.addEventListener("readystatechange", () => {
                if (xhr.readyState === 4) {
                    // console.log('login')
                    // console.log(xhr.responseText)
                    var tmp = JSON.parse(xhr.responseText)
                    // console.log(tmp)
                    if(tmp.token != undefined){
                        
                        var addnow = new Date();
                        addnow.setHours(addnow.getHours()+EXPIRATION_DELTA_HOURS)
                        console.log(addnow)
                        document.cookie = "access_token="+String(tmp.token)+"; expires="+addnow.toUTCString();
                        document.cookie = "expires="+addnow.toUTCString()+"; expires="+addnow.toUTCString();
                        // document.cookie = "ly_code2=" + this.code + ";expires=" + new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)).toUTCString() + ";domain=devbackend425.lychee.pro";
                        localStorage.setItem('account_type', tmp.account_type)
                        localStorage.setItem('vendor_id', tmp.vendor_id)
                        localStorage.setItem('account_name', tmp.account_name)
                        localStorage.setItem('has_bot', tmp.has_bot)
                        localStorage.setItem('has_link_bot', tmp.has_link_bot)
                        if(tmp.has_bot){
                            if(!tmp.has_link_bot){
                                this.$router.push('/chat_bot')
                            }
                            else{
                                this.$router.push('/account_overview')       
                            }
                        }
                        else{
                            this.$router.push('/account_overview')
                        }
                    }
                    else{
                        bus.$emit('alert', {msg: '登入失敗', title: "提示",　check: "我知道了"})
                    }
                }
            });

            xhr.addEventListener("error", ()=>{
                this.$ga.event('Login', 'submitForm', 'Error')
            });
            
            xhr.open("POST", host_url+"api-token-auth/")
            xhr.setRequestHeader("Content-Type", "application/json");
            // xhr.setRequestHeader("X-CSRFToken", this.$cookies.get('csrftoken'));
            xhr.send(data);
        },
        forgot_password_submit(){
            if(this.checkEmail(this.emailField) == false){
                bus.$emit('alert', {msg: '信箱格式不符, 請確認', title: "提示",　check: "我知道了"})
                return
            }
            let data = {
                email: this.emailField
            }
            axios.post(host_url+'forgot_password/', JSON.stringify(data))
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                    this.emailField = ''
                    this.forgot_password_dialog = false
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error) => {
                bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                console.log(error)
            })
        },
        // 確認信箱格式
        checkEmail(val){
            const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (regexp.test(val)){ return true; }
            else { return false; }
        },
    }
}
</script>
<style scoped>
.loginCard{
    width: 450px;
    border-radius: 15px;
    margin-top: 100px;
}
.forgotPassword{
    margin-top: 30px;
    text-decoration:underline; 
    cursor: pointer;
    color: blue;
}
</style>